// Glassmorphism Design System - GettelWeb
// Design moderno com backdrop-filter, transparência e efeitos de vidro

export const GlassmorphismTheme = {
  // ===== CORES GLASSMORPHISM =====
  colors: {
    // Gradientes modernos
    gradients: {
      primary: 'linear-gradient(135deg, rgba(230, 230, 250, 0.3), rgba(176, 196, 222, 0.2))',
      secondary: 'linear-gradient(135deg, rgba(176, 196, 222, 0.2), rgba(135, 206, 235, 0.15))',
      success: 'linear-gradient(135deg, rgba(39, 174, 96, 0.1), rgba(46, 204, 113, 0.1))',
      warning: 'linear-gradient(135deg, rgba(243, 156, 18, 0.1), rgba(241, 196, 15, 0.1))',
      error: 'linear-gradient(135deg, rgba(231, 76, 60, 0.1), rgba(192, 57, 43, 0.1))',
      info: 'linear-gradient(135deg, rgba(52, 152, 219, 0.1), rgba(41, 128, 185, 0.1))',
      // Novos gradientes com lilás claro e azul leve
      lightGlass: 'linear-gradient(135deg, rgba(230, 230, 250, 0.4), rgba(176, 196, 222, 0.2))',
      purpleGlass: 'linear-gradient(135deg, rgba(230, 230, 250, 0.3), rgba(216, 191, 216, 0.2))',
      chart: 'linear-gradient(135deg, rgba(230, 230, 250, 0.2), rgba(176, 196, 222, 0.15))',
    },

    // Cores de fundo com transparência
    backgrounds: {
      glass: 'rgba(255, 255, 255, 0.7)',
      glassDark: 'rgba(230, 230, 250, 0.3)',
      glassLight: 'rgba(255, 255, 255, 0.9)',
      glassDarkLight: 'rgba(230, 230, 250, 0.2)',
      // Novos fundos com lilás claro
      lightPurpleGlass: 'rgba(230, 230, 250, 0.4)',
      lightPurpleGlassLight: 'rgba(230, 230, 250, 0.2)',
      purpleGlass: 'rgba(230, 230, 250, 0.3)',
      purpleGlassLight: 'rgba(230, 230, 250, 0.15)',
    },

    // Cores sólidas para contraste
    solid: {
      primary: '#E6E6FA', // Lilás claro
      secondary: '#B0C4DE', // Azul claro
      success: '#27ae60',
      warning: '#f39c12',
      error: '#e74c3c',
      info: '#3498db',
      text: '#2c3e50', // Texto escuro para contraste com lilás
      textLight: '#5a6c7d', // Cinza médio para texto secundário
      textDark: '#2c3e50', // Texto escuro principal
      white: '#ffffff',
      black: '#2c3e50', // Azul escuro em vez de preto
      // Novas cores para gráficos
      chartPurple: '#E6E6FA',
      chartGreen: '#2ecc71',
      chartBlue: '#B0C4DE',
      chartOrange: '#f39c12',
    },
  },

  // ===== BACKDROP BLUR EFFECTS =====
  backdrop: {
    light: 'backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);',
    medium: 'backdrop-filter: blur(15px); -webkit-backdrop-filter: blur(15px);',
    heavy: 'backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);',
    soft: 'backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px);',
  },

  // ===== SOMBRAS GLASSMORPHISM =====
  shadows: {
    // Sombras sutis com blur
    glass: '0 8px 32px rgba(31, 38, 135, 0.15)',
    glassSoft: '0 4px 16px rgba(31, 38, 135, 0.1)',
    glassHeavy: '0 12px 40px rgba(31, 38, 135, 0.2)',
    
    // Sombras com gradiente
    glassAccent: '0 8px 24px rgba(102, 126, 234, 0.2)',
    glassAccentBlue: '0 8px 24px rgba(74, 144, 226, 0.2)',
    
    // Sombra para elementos flutuantes
    floatingLight: '0 10px 30px rgba(0, 0, 0, 0.08)',
    floatingMedium: '0 15px 40px rgba(0, 0, 0, 0.12)',
    floatingHeavy: '0 20px 50px rgba(0, 0, 0, 0.15)',
  },

  // ===== BORDAS GLASSMORPHISM =====
  borders: {
    // Borda com gradiente e transparência
    glassLight: '1px solid rgba(255, 255, 255, 0.5)',
    glassDark: '1px solid rgba(0, 0, 0, 0.1)',
    glassAccent: '1px solid rgba(102, 126, 234, 0.3)',
    glassAccentBlue: '1px solid rgba(74, 144, 226, 0.3)',
  },

  // ===== BORDER RADIUS =====
  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    xxl: '24px',
    full: '50%',
  },

  // ===== ESPAÇAMENTO =====
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },

  // ===== TIPOGRAFIA =====
  typography: {
    fontFamily: {
      primary: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
      mono: '"Fira Code", "Monaco", monospace',
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },

  // ===== TRANSIÇÕES =====
  transitions: {
    fast: '150ms ease-in-out',
    normal: '250ms ease-in-out',
    slow: '350ms ease-in-out',
  },

  // ===== COMPONENTES PRÉ-CONFIGURADOS =====
  components: {
    // Card com glassmorphism
    glassCard: {
      background: 'rgba(255, 255, 255, 0.7)',
      backdropFilter: 'blur(15px)',
      border: '1px solid rgba(255, 255, 255, 0.5)',
      borderRadius: '16px',
      padding: '20px',
      boxShadow: '0 8px 32px rgba(31, 38, 135, 0.15)',
      color: '#2c3e50',
    },

    // Card escuro com glassmorphism
    glassCardDark: {
      background: 'rgba(230, 230, 250, 0.3)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid rgba(176, 196, 222, 0.3)',
      borderRadius: '16px',
      padding: '20px',
      boxShadow: '0 8px 32px rgba(176, 196, 222, 0.2)',
      color: '#2c3e50',
    },

    // Card para gráficos com lilás claro
    glassChartCard: {
      background: 'rgba(230, 230, 250, 0.3)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid rgba(176, 196, 222, 0.3)',
      borderRadius: '16px',
      padding: '24px',
      boxShadow: '0 8px 32px rgba(176, 196, 222, 0.2)',
      color: '#2c3e50',
    },

    // Card para estatísticas
    glassStatCard: {
      background: 'rgba(230, 230, 250, 0.3)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid rgba(176, 196, 222, 0.3)',
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 4px 16px rgba(176, 196, 222, 0.2)',
      color: '#2c3e50',
      transition: 'all 0.3s ease',
    },

    // Botão com glassmorphism
    buttonGlass: {
      background: 'rgba(102, 126, 234, 0.15)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(102, 126, 234, 0.3)',
      borderRadius: '12px',
      padding: '10px 20px',
      fontSize: '0.95rem',
      fontWeight: 600,
      color: '#667eea',
      cursor: 'pointer',
      transition: '250ms ease-in-out',
      boxShadow: '0 4px 16px rgba(102, 126, 234, 0.1)',
    },

    // Botão primário
    buttonPrimary: {
      background: 'linear-gradient(135deg, #E6E6FA 0%, #B0C4DE 100%)',
      border: 'none',
      borderRadius: '12px',
      padding: '12px 24px',
      fontSize: '0.95rem',
      fontWeight: 600,
      color: '#2c3e50',
      cursor: 'pointer',
      transition: '250ms ease-in-out',
      boxShadow: '0 8px 24px rgba(176, 196, 222, 0.3)',
    },

    // Input com glassmorphism
    inputGlass: {
      background: 'rgba(255, 255, 255, 0.5)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.7)',
      borderRadius: '12px',
      padding: '12px 16px',
      fontSize: '0.95rem',
      color: '#2c3e50',
      transition: '250ms ease-in-out',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
    },

    // Badge com glassmorphism
    badge: {
      background: 'rgba(102, 126, 234, 0.15)',
      backdropFilter: 'blur(8px)',
      border: '1px solid rgba(102, 126, 234, 0.3)',
      borderRadius: '20px',
      padding: '4px 12px',
      fontSize: '0.75rem',
      fontWeight: 600,
      color: '#667eea',
    },

    // Divider com gradiente
    divider: {
      background: 'linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.2), transparent)',
      height: '1px',
      margin: '20px 0',
    },

    // Modal components
    modalHeader: {
      background: 'rgba(230, 230, 250, 0.3)',
      backdropFilter: 'blur(15px)',
      WebkitBackdropFilter: 'blur(15px)',
      borderBottom: '1px solid rgba(176, 196, 222, 0.3)',
      color: '#2c3e50',
      fontWeight: 600,
      padding: '20px 24px',
    },

    modalContent: {
      background: 'rgba(255, 255, 255, 0.5)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      padding: '24px',
      color: '#2c3e50',
    },

    modalActions: {
      background: 'rgba(230, 230, 250, 0.2)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      borderTop: '1px solid rgba(176, 196, 222, 0.3)',
      padding: '16px 24px',
    },
  },
};

// ===== UTILITY FUNCTIONS =====

export const createGlassStyle = (intensity: 'light' | 'medium' | 'heavy' = 'medium') => ({
  background: GlassmorphismTheme.colors.backgrounds.glass,
  backdropFilter: `blur(${intensity === 'light' ? '10' : intensity === 'medium' ? '15' : '20'}px)`,
  WebkitBackdropFilter: `blur(${intensity === 'light' ? '10' : intensity === 'medium' ? '15' : '20'}px)`,
  border: GlassmorphismTheme.borders.glassLight,
  boxShadow: GlassmorphismTheme.shadows.glass,
});

export const createGradientOverlay = (color: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' = 'primary') => ({
  background: GlassmorphismTheme.colors.gradients[color],
  backdropFilter: 'blur(5px)',
  WebkitBackdropFilter: 'blur(5px)',
});

export const createGlassButton = (variant: 'primary' | 'glass' = 'primary') => 
  variant === 'glass' 
    ? GlassmorphismTheme.components.buttonGlass 
    : GlassmorphismTheme.components.buttonPrimary;

// Export como default para facilitar imports
export default GlassmorphismTheme;
